import { render, staticRenderFns } from "./isoReviewReportDetail.vue?vue&type=template&id=166bde70"
import script from "./isoReviewReportDetail.vue?vue&type=script&lang=js"
export * from "./isoReviewReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('166bde70')) {
      api.createRecord('166bde70', component.options)
    } else {
      api.reload('166bde70', component.options)
    }
    module.hot.accept("./isoReviewReportDetail.vue?vue&type=template&id=166bde70", function () {
      api.rerender('166bde70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/iso/isoReviewReportDetail.vue"
export default component.exports